<div
    class="ticker-container"
    [ngClass]="{ 'ticker-up': ticker.length && ticker_animation, 'ticker-down': !ticker.length && ticker_animation }"
    [ngStyle]="{ padding: ticker.length ? '10px 0' : '0' }"
>
    <mat-icon [ngStyle]="{ display: show_matches ? 'block' : 'none' }" (click)="handleTennisMatch()">keyboard_arrow_down</mat-icon>
    @if (ticker.length) {
        <app-carousel [config]="splideConfig" [index]="index" [isTicker]="true" (slideData)="handleNewData($event)">
            @for (match of ticker; track match; let i = $index) {
                <app-slide class="match-slides" (click)="goTo(i)">
                    <div class="match-text" (click)="handleTennisMatch()">
                        <div class="tournament_name">{{ match.data.match.tournament_name }} :</div>
                        <div class="body">{{ match.data.body }}</div>
                    </div>
                </app-slide>
            }
        </app-carousel>
    }
    @if (placeholder.length) {
        <app-carousel [config]="splideConfig" (slideData)="handleNewData($event)">
            <app-slide class="match-slides">
                <div class="match-text" (click)="handleTennisMatch()">
                    <div class="tournament_name">{{ placeholder[0].data.match.tournament_name }} :</div>
                    <div class="body">{{ placeholder[0].data.body }}</div>
                </div>
            </app-slide>
        </app-carousel>
    }
    <div class="background"></div>
</div>
